/// <amd-module name="Build/Common/Commands/Constants" />
export namespace DisallowedCharacters
{
    export const DisallowedPipelineNameCharacters = '<>|\\:$@"/';
    export const DisallowedFolderPathCharacters = '<>|:$@"/%+*?';
    export const DisallowedFolderNameCharacters = DisallowedFolderPathCharacters + '\\';
}

export namespace CharacterLimits
{
    export const MaxPathNameLength = 248;
}